export default {
  cake: {
    56: '0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
    97: '',
  },
  masterChef: {
    56: '0xa1FEaEe6253D389Cf88d3ba65c21f964725b9172',
    97: '',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '',
  },
  btcb: {
    56: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
    97: '',
  },
  eth: {
    56: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
    97: '',
  },
  beth: {
    56: '0x250632378e573c6be1ac2f97fcdf00515d0aa91b',
    97: '',
  },
  borg: {
    56: '0xe9828045632b32e2aac7f3a4c1511c0d8965576c',
    97: '',
  },
  borgdai: {
    56: '0xacd9c515a43e80d67c8a5982e6ef2ddc4c41629a',
    97: '',
  },
  jemhad: {
    56: '0xd423fb0d98759b97566ec7113bfe2d73f845a887',
    97: '',
  },
  rfibsc: {
    56: '0x122bf64edc48d1fb0c08f6c2bd7bbee5c3546038',
    97: '',
  },
  doge: {
    56: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
    97: '',
  },
  auto: {
    56: '0xa184088a740c695e156f91f5cc086a06bb78b827',
    97: '',
  },
  klingethlp: {
    56: '0x0f7b177c54803a6d21422c22a43ad7c886e7554e',
    97: '',
  },
  dot: {
    56: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
    97: '',
  },
  ears: {
    56: '0x0ec4b89462557150302ac6e81270a081f2e3bd20',
    97: '',
  },
  kling: {
    56: '0xf6527df4592bd17cf5c697330f38781fefe7def6',
    97: '',
  },
}
